module.exports = __webpack_public_path__ + "static/character5.33f9690e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_photos/character5.svg
// module id = 1096
// module chunks = 35783957827783